export default "__VITE_ASSET__YiWiKkqF__"